import BlogComponent from '../components/Common/BlogComponent';

function Main() {
  return (
    <div className="Main">
      <header className="App-header">
        <h1>김민규의 개인 블로그</h1>
        <p>ㅇㅇ</p>
      </header>

      <main>
        <BlogComponent 
          title="첫 번째 블로그 포스트"
          username="김민규"
          date="2023-10-01"
          link="https://example.com/post1"
        />
      </main>
    </div>
  );
}

export default Main;
